import React, { useState, useMemo } from 'react';
import { graphql, Link } from 'gatsby';
import get from 'lodash/get';
import NewsCard from '../components/NewsCard';
import {
  CardContainer,
  TagButtonGroup,
  Title,
  MainContainer,
  ShowMore,
} from '../styles/news.template.styled';
import SEO from '../components/seo';
import CustomPagination from '../components/customPagination';
import BannerGatsbyImg from '../components/BannerGatsbyImg';
import { getPrevNextPage } from '../utils/helper';

export const Head = (props) => {
  const currentPage = get(props, 'pageContext.currentPage');
  const totalPages = get(props, 'pageContext.totalPostTagsPages');
  const activeSlug = get(props, 'pageContext.slug');
  const baseUrl = `/news/tags/${activeSlug}/`;
  const activeTag = get(props, 'pageContext.tag');

  const { prevPage, nextPage } = getPrevNextPage(
    baseUrl,
    currentPage,
    totalPages,
  );

  const canonicalUrl = `${process.env.GATSBY_SITE_URL}${baseUrl}`;

  const seoData = {
    title: `${
      activeTag ? `${activeTag} |` : ''
    } News | Pandemic Action Network`,
    description: get(props, 'data.allWpPage.nodes[0].seo.metaDesc'),
    image: get(
      props,
      'data.allWpPage.nodes[0].seo.opengraphImage.mediaItemUrl',
    ),
    pageUrl: get(props, 'data.allWpPage.nodes[0].seo.opengraphUrl'),
    prevPage: prevPage,
    nextPage: nextPage,
    slug: currentPage === 1 ? baseUrl : `${baseUrl}${currentPage}/`,
    canonicalUrl,
  };

  return <SEO seoProps={seoData} />;
};

const Tags = (props) => {
  const [isShowing, setIsShowing] = useState(false);
  const allNews = get(props, 'data.allWpPost.nodes');
  const currentPage = get(props, 'pageContext.currentPage');
  const totalPages = get(props, 'pageContext.totalPostTagsPages');
  const activeTag = get(props, 'pageContext.tag');
  const activeSlug = get(props, 'pageContext.slug');
  const bannerImgUrl = get(
    props,
    'data.allWpPage.nodes[0].featuredImage.node.localFile',
  );
  const bannerTitle = get(
    props,
    'data.allWpPage.nodes[0].newsPageFields.bannerTitle',
  );
  const toFilterTags = allNews.map((value) =>
    value.tags.nodes.map((tag) => tag),
  );
  const baseUrl = `/news/tags/${activeSlug}/`;

  const myArr = [];
  toFilterTags.map((val) => {
    val.map((elem, i) => {
      return myArr.push(elem);
    });
  });

  let seen = Object.create(null),
    filterTags = myArr.filter((o) => {
      var key = ['name', 'slug'].map((k) => o[k]).join('|');
      if (!seen[key]) {
        seen[key] = true;
        return true;
      }
    });

  const pagination = useMemo(() => {
    return (
      <CustomPagination
        baseUrl={baseUrl}
        currentPage={currentPage}
        totalPages={totalPages}
        sectionId='#tags-title'
      />
    );
  }, [currentPage]);

  return (
    <>
      <BannerGatsbyImg title={bannerTitle} image={bannerImgUrl} />
      <div className='wrapper'>
        <MainContainer>
          <Title id='tags-title'>Related Tags</Title>
          <TagButtonGroup
            isShowing={filterTags?.length > 10 ? isShowing : true}
          >
            <li>
              <Link
                to={`/news/tags/#tags-title`}
                className={activeSlug === 'all' ? 'active' : null}
                title='All'
              >
                All
              </Link>
            </li>
            {filterTags?.length &&
              filterTags?.map((tag, index) => (
                <li key={index}>
                  <Link
                    to={`/news/tags/${tag.slug}/#tags-title`}
                    className={tag.name === activeTag ? 'active' : null}
                    title={tag.name}
                  >
                    {tag.name}
                  </Link>
                </li>
              ))}
          </TagButtonGroup>
          {filterTags?.length > 10 && (
            <ShowMore
              title='Show More'
              onClick={() => setIsShowing(!isShowing)}
              isShowing={isShowing}
            >
              {isShowing ? 'Show Less' : 'Show More'}
            </ShowMore>
          )}
          <CardContainer>
            {allNews.map((news, index) => {
              return (
                <li key={index} className='news'>
                  <NewsCard {...news} noContent />
                </li>
              );
            })}
          </CardContainer>
          {totalPages > 1 && pagination}
        </MainContainer>
      </div>
    </>
  );
};

export const pageQuery = graphql`
  query AllTagsPostQuery($skip: Int!, $limit: Int!, $slug: String) {
    allWpPost(
      limit: $limit
      skip: $skip
      sort: { date: DESC }
      filter: { tags: { nodes: { elemMatch: { slug: { eq: $slug } } } } }
    ) {
      nodes {
        title
        id
        slug
        content
        postsFields {
          postSubTitle
          author {
            name
            slug
            id
          }
        }
        featuredImage {
          node {
            mediaItemUrl
            title
            localFile {
              childImageSharp {
                gatsbyImageData(
                  placeholder: BLURRED
                  width: 1366
                  height: 768
                  formats: WEBP
                )
              }
            }
          }
        }
        author {
          node {
            name
            slug
            id
          }
        }
        date
        tags {
          nodes {
            name
            slug
            id
          }
        }
      }
    }
    allWpPage(filter: { slug: { eq: "news" } }) {
      nodes {
        title
        id
        seo {
          metaDesc
          title
          opengraphImage {
            mediaItemUrl
          }
          opengraphUrl
        }
        featuredImage {
          node {
            altText
            mediaItemUrl
            localFile {
              childImageSharp {
                gatsbyImageData(placeholder: BLURRED, formats: WEBP)
              }
            }
          }
        }
        newsPageFields {
          bannerTitle
        }
      }
    }
  }
`;

export default Tags;
